/* eslint-disable import/no-unresolved */
/* eslint-disable no-param-reassign */
/* eslint-disable no-nested-ternary */
import {
    useCallback,
    useEffect,
} from 'react';
import {
    addEdge,
    removeElements,
    getOutgoers,
    getIncomers,
} from 'react-flow-renderer';
import { useLocation, useHistory } from 'react-router-dom';
import { useQuery, useMutation } from '@apollo/client';

import { withStateHandlers, getNodeMaxId } from 'utils';
import { GET_PROJECT_CONFIGURATION, GET_FILTER_FUNCTIONS } from 'Apollo/Queries/DataRecon/DataConfiguration';
import { CREATE_OR_UPDATE_FLOW_CONFIG, RUN_RECONCILIATION_FLOW_CONFIG } from 'Apollo/Mutations/DataRecon/DataConfiguration';
import {
    activeDataReconMenuVar, showDataReconMenusVar, leftNavigationItemsVar,
    currentLeftMenuVar,
} from 'Apollo/config';
import { ModuleEnum } from 'constants';
import crossReportImg from 'assets/images/cross-report-black.svg';
import DataConfig from '../components';
import 'react-flow-renderer/dist/style.css';
import 'react-flow-renderer/dist/theme-default.css';
import '../styles/index.scss';
import '../styles/dnd.scss';
import '../styles/datepicker.scss';

const initialState = {
    reactFlowInstance: null,
    nodeName: {},
    elements: [],
    showColumnsModal: false,
    selectedNode: {},
    saveConfig: {},
    colsData: [],
    error: null,
    filters: [],
    flowInstance: null,
    breadCrumbItems: null,
    success: null,
    showAlert: false,
    filterFunctions: [],
    showWarningModal: false,
    confirmReset: false,
    projectConfig: {},
};
let id = 0;

const noConfigurationErrorMessage = 'No Configuration Flow found!';

const listItems = [
    [
        <i key={1} className="appkiticon icon-bar-chart-outline" style={{ fontSize: '1.5rem', color: 'white', top: '100px' }} />,
        <span key={2} className="a-nav-item-text" style={{ fontSize: '0.7rem' }}>Data Reconciliation</span>,
    ],
    [
        <i key={1} className="appkiticon icon-ticket-outline" style={{ fontSize: '1.5rem', color: '#464646', top: '100px' }} />,
        <span key={2} className="a-nav-item-text" style={{ color: '#464646', fontSize: '0.7rem' }}>Rule Engine</span>,
    ],
    [
        <img
            key={1}
            src={crossReportImg}
            alt="Cross Report"
            style={{
                width: '30.84px', height: '25px', top: '100px',
            }}
        />,
        <span key={2} className="a-nav-item-text" style={{ color: '#464646', fontSize: '0.7rem' }}>Cross Report Validation</span>,
    ],
    [
        <i key={1} className="appkiticon icon-grow-revenue-outline" style={{ fontSize: '1.5rem', color: '#464646', top: '100px' }} />,
        <span key={2} className="a-nav-item-text" style={{ color: '#464646', fontSize: '0.7rem' }}>Trend Analytics</span>,
    ],
];

const getUpdatedFilter = (filters, e) => filters.map(f => (
    f.functionName === e
        ? { ...f, isSelected: true }
        : { ...f, isSelected: false }
));

const validateOutGoers = (element, flow) => {
    if ((element.type === 'input' || element.type === 'special') && getOutgoers(element, flow.elements).length === 0) {
        return true;
    }
    return false;
};

const validateIncomers = (element, flow, noOfIncomers) => {
    if (element.type === 'default' && getIncomers(element, flow.elements).length < noOfIncomers) {
        return true;
    }
    return false;
};

const getUpdatedColData = (projectConfig, filterFunctions) => projectConfig?.selectedColumnsData.map(item => {
    const newCols = item.columns.map(col => {
        const newFilters = filterFunctions.filter(({ functionId: id1 }) => !col.filters.some(({ functionId: id2 }) => id2 === id1)).map(fil => ({
            ...fil,
            displayName: fil.functionName.charAt(0).toUpperCase() + fil.functionName.slice(1),
            isSelected: false,
        }));
        return {
            ...col,
            filters: [...col.filters, ...newFilters],
        };
    });
    return {
        ...item,
        columns: newCols,
    };
});

const getSelectedColumnData = (name, data, checked) => {
    let checkedAll;
    let colsData;
    if (name === 'checkAll') {
        checkedAll = checked;
        colsData = data.map(item => ({ ...item, isChecked: checked }));
    } else {
        colsData = data.map(item => (item.column === name ? { ...item, isChecked: checked } : item));
        checkedAll = data.every(item => item.isChecked);
    }
    return { colsData, checkedAll };
};

const getFilteredData = (e, column, data) => data && data.map(item => {
    if (item.column === column) {
        return {
            ...item,
            filters: getUpdatedFilter(item.filters, e),
            operation: e,
            transformation: '',
            start_date: '',
            end_date: '',
        };
    }
    return item;
});

/* function to add handlers of the components. */
const addHandlers = (state, props) => ({
    getId: () => {
        const nodeId = `dndnode_${id}`;
        id += 1;
        return nodeId;
    },
    onConnect: params => props.setElements(els => addEdge(params, els)),
    onElementsRemove: elementsToRemove => props.setElements(els => removeElements(elementsToRemove, els)),
    onElementClick: (event, element) => {
        props.setError(null);
        props.setSelectedNode(element);
    },
    onLoad: _reactFlowInstance => props.setReactFlowInstance(_reactFlowInstance),
    onDragOver: event => {
        event.preventDefault();
        event.dataTransfer.dropEffect = 'move';
    },
    onHandleChange: event => {
        const { target: { name, checked } } = event;
        props.setColsData(prevState => {
            const index = prevState.findIndex(x => x.id === props.selectedNode.id);
            const { id: nId } = prevState.filter(item => item.id === props.selectedNode.id)[0];
            const { columns } = prevState.filter(item => item.id === props.selectedNode.id)[0];
            const { colsData, checkedAll } = getSelectedColumnData(name, columns, checked);
            return [
                ...prevState.slice(0, index),
                {
                    id: nId,
                    columns: colsData,
                    allChecked: checkedAll,
                },
                ...prevState.slice(index + 1),
            ];
        });
    },
    onFilterChange: (e, column) => {
        props.setColsData(prevState => {
            const index = prevState.findIndex(x => x.id === props.selectedNode.id);
            const { allChecked, id: nId } = prevState.filter(item => item.id === props.selectedNode.id)[0];
            let { columns: data } = prevState.filter(item => item.id === props.selectedNode.id)[0];
            data = getFilteredData(e, column, data);
            return [
                ...prevState.slice(0, index),
                {
                    id: nId,
                    columns: data,
                    allChecked,
                },
                ...prevState.slice(index + 1),
            ];
        });
    },
    onOperationChange: (value, column) => {
        props.setColsData(prevState => {
            const index = prevState.findIndex(x => x.id === props.selectedNode.id);
            const { allChecked, id: nId } = prevState.filter(item => item.id === props.selectedNode.id)[0];
            let { columns: data } = prevState.filter(item => item.id === props.selectedNode.id)[0];
            data = data && data.map(item => {
                if (item.column === column && item.dataType !== 'date') {
                    return {
                        ...item,
                        transformation: value,
                    };
                }
                if (item.column === column && item.dataType === 'date') {
                    return {
                        ...item,
                        start_date: value[0],
                        end_date: value[1],
                    };
                }
                return item;
            });
            return [
                ...prevState.slice(0, index),
                {
                    id: nId,
                    columns: data,
                    allChecked,
                },
                ...prevState.slice(index + 1),
            ];
        });
    },
    validateFlow: () => {
        if (props.reactFlowInstance) {
            const flow = props.reactFlowInstance.toObject();
            if (flow?.elements?.length > 0) {
                const nodes = flow?.elements.filter(e => (!e.source && !e.target));

                let outGoersFlag = false;
                let incomersFlag = false;
                const noOfIncomers = 2;
                nodes.forEach(element => {
                    outGoersFlag = validateOutGoers(element, flow);
                    incomersFlag = validateIncomers(element, flow, noOfIncomers);
                });
                if (outGoersFlag || incomersFlag) {
                    return false;
                }
                return true;
            }
            return false;
        }
        return false;
    },
    onSaveConfig: config => {
        props.setSaveConfig(prevState => ({
            ...prevState,
            ...config,
        }));
        if (props.reactFlowInstance) {
            const flow = props.reactFlowInstance.toObject();
            props.setFlowInstance(flow);
        }
    },
    resetConfig: () => {
        props.setShowWarningModal(true);
    },
    getError: err => {
        if (!err) {
            props.setError({ message: noConfigurationErrorMessage });
        } else {
            props.setError(err);
        }
    },
    saveFlowConfig: async (createOrUpdateFlowConfig, refetch, validateFlow) => {
        try {
            if (!validateFlow()) {
                throw new Error('Invalid Configuration! Please connect using Reconciliation Type.');
            }
            const { data: createConfigData } = await createOrUpdateFlowConfig();
            if (createConfigData.createOrUpdateFlowConfig) {
                props.setSuccess({ message: 'Configuration Saved!' });
                props.setConfirmReset(false);
                refetch();
            } else {
                throw new Error('An error occurred while saving Configuration!');
            }
            props.setError(null);
            props.setShowAlert(true);
        } catch (err) {
            props.setError(err);
            props.setShowAlert(true);
        }
    },
    restoreFlow: async getError => {
        try {
            const isProjectConfigAvailable = Object.keys(props.projectConfig).length > 0;
            const isDiagramFlowAvailable = props.projectConfig.diagramFlow
            && Object.keys(props.projectConfig.diagramFlow).length;
            const isFlowConfigAvailable = props.projectConfig.flowConfig
            && Object.keys(props.projectConfig.flowConfig).length;
            if (isProjectConfigAvailable && props.filterFunctions && isDiagramFlowAvailable && isFlowConfigAvailable) {
                const updatedColData = getUpdatedColData(props.projectConfig, props.filterFunctions);
                props.setConfirmReset(false);
                props.setElements(props?.projectConfig?.diagramFlow.elements || []);
                props.setSaveConfig(props?.projectConfig?.flowConfig || {});
                props.setFlowInstance(props?.projectConfig?.diagramFlow || {});
                props.setColsData(updatedColData || props.colsData);
                if (props?.projectConfig?.diagramFlow?.elements.length > 0) {
                    const maxId = getNodeMaxId(props.projectConfig.diagramFlow.elements);
                    id = maxId + 1;
                }
            } else {
                throw new Error(noConfigurationErrorMessage);
            }
        } catch (err) {
            getError(err);
            props.setShowAlert(true);
        }
    },
    saveAndRunFlowConfig: async (validateFlow, runReconciliation) => {
        try {
            if (!validateFlow()) {
                throw new Error('Invalid Configuration! Please connect using Reconciliation Type.');
            }
            runReconciliation();
        } catch (err) {
            props.setError(err);
            props.setShowAlert(true);
        }
    },
    resetFlow: () => {
        props.setElements([]);
        props.setColsData([]);
        props.setFlowInstance(null);
        props.setSaveConfig({});
        props.setSelectedNode({});
        id = 0;
    },
});
const DataConfiguration = () => {
    /* function to get all state, props and handlers. */
    const allProps = withStateHandlers(addHandlers, initialState);
    const location = useLocation();
    const history = useHistory();
    const { projectId, tenantId, project } = location.state;
    /* function to navigate to projects page */
    const navigateToProjects = () => history.push(
        {
            pathname: '/projects',
            state: {
                tenantId,
            },
        },
    );
    /* function to navigate to Data Recon home page */
    const navigateToHome = () => history.push(
        {
            pathname: '/data-recon-home',
            state: {
                tenantId,
            },
        },
    );
    /* function to navigate to data lineage upload page */
    const navigateToDataLineageUpload = () => history.push({
        pathname: '/data-lineage-upload',
        state: {
            tenantId, project,
        },
    });
    /* apollo query to get project configuration */
    const {
        data, loading, error, refetch,
    } = useQuery(GET_PROJECT_CONFIGURATION, {
        fetchPolicy: 'no-cache',
        variables: {
            input: {
                pageSize: 10,
                pageNumber: 1,
                projectId: Number(projectId),
            },
        },
    });
    /* apollo query to get filter functions */
    const { data: filterFunctions } = useQuery(GET_FILTER_FUNCTIONS, {
        fetchPolicy: 'no-cache',
        variables: {
            input: {
                pageSize: 15,
                pageNumber: 1,
                isPreview: true,
            },
        },
    });
    /* apollo mutation to upsert reconciliation flow config */
    const [createOrUpdateFlowConfig, { error: createError }] = useMutation(CREATE_OR_UPDATE_FLOW_CONFIG, {
        variables: {
            input: {
                projectId: parseInt(projectId, 10),
                flowConfig: allProps.saveConfig,
                diagramFlow: allProps.flowInstance,
                selectedColumnsData: allProps.colsData,
            },
        },
    });
    /* apollo mutation to run reconciliation flow config */
    const [runReconciliation, { error: runError, loading: runLoading, data: runData }] = useMutation(RUN_RECONCILIATION_FLOW_CONFIG, {
        variables: {
            input: {
                projectId: parseInt(projectId, 10),
                flowConfig: allProps.saveConfig,
                diagramFlow: allProps.flowInstance,
                selectedColumnsData: allProps.colsData,
                pageSize: 10,
                pageNumber: 1,
            },
        },
    });
    /* callback function called on click of SAVE button */
    const onSave = useCallback(() => {
        allProps.saveFlowConfig(createOrUpdateFlowConfig, refetch, allProps.validateFlow);
    }, [allProps.reactFlowInstance, allProps.setFlowInstance]);

    /* callback function called on click of RUN RECONCILIATION button */
    const onRun = useCallback(
        () => {
            allProps.saveAndRunFlowConfig(allProps.validateFlow, runReconciliation);
        },
        [allProps.reactFlowInstance, allProps.setFlowInstance],
    );
    /* callback function called on click of Restore button */
    const onRestore = useCallback(() => {
        allProps.restoreFlow(allProps.getError);
    }, [allProps.setElements, allProps.projectConfig, allProps.setSaveConfig, allProps.filterFunctions]);
    /* callback function called on click of Reset button */
    const onReset = useCallback(() => {
        allProps.resetFlow();
    }, [allProps.setElements, allProps.setSaveConfig, allProps.setFlowInstance, allProps.setColsData]);
    /* Breadcrumb Items */
    const breadCrumbItems = [
        {
            link: '',
            value: <span className="appkiticon icon-home-fill font-16" onClick={navigateToHome} role="presentation" />,
        },
        {
            link: '',
            value: <span className="a-breadcrumb-item-text" onClick={navigateToProjects} role="presentation"> Projects </span>,
        },
        {
            link: '',
            value: (
                <span
                    className="a-breadcrumb-item-text"
                    onClick={navigateToDataLineageUpload}
                    role="presentation"
                >
                    {project?.projectName}
                </span>
            ),
        },
        {
            link: '',
            value: (
                <span className="a-breadcrumb-item-text">
                    Data Configuration
                </span>
            ),
        },
    ];
    /* Set properties to allProps object */
    allProps.navigateToDataLineageUpload = navigateToDataLineageUpload;
    allProps.breadCrumbItems = breadCrumbItems;
    allProps.onSave = onSave;
    allProps.onRun = onRun;
    allProps.runLoading = runLoading;
    allProps.onReset = onReset;
    allProps.onRestore = onRestore;
    /* side effect called when component loads */
    useEffect(() => {
        leftNavigationItemsVar(listItems);
        currentLeftMenuVar(ModuleEnum.DATARECONCILIATION);
    }, []);
    /* side effect when location is changed */
    useEffect(() => {
        allProps.setElements(location?.state?.diagramFlow?.elements || []);
        allProps.setSaveConfig(location?.state?.flowConfig || {});
        allProps.setFlowInstance(location?.state?.diagramFlow || {});
        allProps.setColsData(location?.state?.selectedColumnsData || []);
        if (location?.state?.diagramFlow?.elements.length > 0) {
            const maxId = getNodeMaxId(location.state.diagramFlow.elements);
            id = maxId + 1;
        }
        showDataReconMenusVar(true);
        activeDataReconMenuVar('projects');
    }, [location]);
    /* side effect when project configuration is changed */
    useEffect(() => {
        if (data) {
            allProps.setProjectConfig(data?.getChildProjectsConfiguration?.projectConfig);
        }
    }, [data]);
    /* side effect when project configuration is loading */
    useEffect(() => {
        allProps.isProjectConfigLoading = loading && !location?.state?.flowConfig;
    }, [loading]);
    /* side effect if configuration loading error or no configuration found set error state variable */
    useEffect(() => {
        if (error || (data && Object.keys(data?.getChildProjectsConfiguration?.projectConfig).length === 0)) {
            allProps.setError({ message: noConfigurationErrorMessage });
            allProps.showAlert(true);
        }
    }, [error]);
    /* side effect to set error when createError or runError is changed */
    useEffect(() => {
        const isError = createError || runError;
        if (isError) {
            allProps.setError(isError);
            allProps.setShowAlert(true);
        }
    }, [runError, createError]);
    /* side effect when project configuration is available */
    useEffect(() => {
        if (!allProps.confirmReset && allProps.elements.length === 0 && allProps?.projectConfig?.diagramFlow && Object.keys(allProps?.projectConfig?.diagramFlow).length > 0) {
            allProps.setFlowInstance(allProps.projectConfig.diagramFlow);
            onRestore();
        }
    }, [allProps.projectConfig, allProps.elements]);
    /* side effect when filter functions is available */
    useEffect(() => {
        allProps.setFilterFunctions(filterFunctions?.getReconFunctions || []);
    }, [filterFunctions]);
    /* side effect to set confirmReset state variable when user confirms to reset */
    useEffect(() => {
        if (allProps.confirmReset) {
            onReset();
        }
    }, [allProps.confirmReset]);
    /* side effect when run reconciliation data is available, redirect to Recon Status page */
    useEffect(() => {
        if (runData?.runReconciliation) {
            history.push({
                pathname: '/datareconciliationstatus',
                state: {
                    projectId,
                    tenantId,
                    project,
                    reconStartTime: runData.runReconciliation,
                },
            });
        }
    }, [runData]);
    return DataConfig(allProps);
};

export default DataConfiguration;
